// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserTrialExpiration_wrapper__V5WRh","upgradeButton":"UserTrialExpiration_upgradeButton__Yzej2"};